import { Injectable } from '@angular/core';

declare var feather: any;

@Injectable({
  providedIn: 'root'
})
export class FeatherIconService {
  private isFeatherLoaded = false;
  private loadAttempts = 0;
  private readonly maxAttempts = 50; // 5 segundos máximo

  constructor() {
    this.waitForFeather();
  }

  /**
   * Espera a que la librería feather esté disponible
   */
  private waitForFeather(): void {
    const checkFeather = () => {
      if (feather !== undefined) {
        this.isFeatherLoaded = true;
        console.log('Feather Icons cargado correctamente');
      } else if (this.loadAttempts < this.maxAttempts) {
        this.loadAttempts++;
        setTimeout(checkFeather, 100);
      } else {
        console.error('Feather Icons no pudo cargarse después de múltiples intentos');
      }
    };
    checkFeather();
  }

  /**
   * Reemplaza los iconos feather en el DOM
   * Usa setTimeout para asegurar que el DOM esté renderizado
   */
  replace(): void {
    setTimeout(() => {
      if (this.isFeatherLoaded && feather !== undefined) {
        try {
          feather.replace();
        } catch (error) {
          console.error('Error al reemplazar iconos feather:', error);
        }
      } else {
        console.warn('Feather Icons aún no está disponible');
      }
    }, 0);
  }

  /**
   * Verifica si feather está disponible
   */
  isLoaded(): boolean {
    return this.isFeatherLoaded && feather !== undefined;
  }
}
